import Sidebar from './Sidebar';

const Layout = ({ children }) => {
  return (
    <div className="flex h-screen w-full bg-page font-body text-neutral-900 antialiased overflow-hidden">
      <Sidebar />
      <main className="flex-1 overflow-y-auto h-full p-4 md:p-8 lg:px-12 scrollbar-thin">
        <div className="max-w-7xl mx-auto flex flex-col gap-8">
          {children}
        </div>
      </main>
    </div>
  );
};

export default Layout;
